<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Intro: Why Revival?</a></div>
<div class="SOM_part"><a href="#/p1">PART ONE: DEFINING REVIVAL</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><span class="mev3">1</span>  Revival for the Rest of Us</a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample"><span class="mev3">2</span> From Holy Discontent to Crucified Hope</span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><span class="mev3">3</span> From Crisis of Faith to Breakthrough Faith</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">PART TWO: EXPERIENCING REVIVAL</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><span class="mev3">4</span> Consecration</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><span class="mev3">5</span> Calling</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><span class="mev3">6</span> Contending</span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample"><span class="mev3">7</span> Character</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">PART THREE: LEADING REVIVAL</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><span class="mev3">8</span> All Play</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><span class="mev3">9</span> Mystery and Strategy Paradox</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><span class="mev3">10</span> Communal Discernment</span></div>
<div class="SOM_chap"><span href="#/p3chap4" title="Link target outside of Sample"><span class="mev3">11</span> Kingdom Building</span></div>
<div class="SOM_appen_autre"><span href="#/p3chap5" title="Link target outside of Sample">Outro: Already and Not Yet</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Praise for <i>Longing for Revival</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?2f35ee70